
    require(
      "!../../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../node_modules/babel-loader/lib/index.js?{\"presets\":[\"/repo/website/node_modules/babel-preset-react/lib/index.js\",\"/repo/website/node_modules/babel-preset-es2015/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-1/lib/index.js\",\"/repo/website/node_modules/babel-preset-env/lib/index.js\",\"/repo/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/repo/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/repo/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/repo/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./index.js") })
        }
      }, "component---src-pages-index-index-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=component---src-pages-index-index-js!./src/pages/index/index.js
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=component---src-pages-index-index-js!./src/pages/index/index.js
// module chunks = 15178676390636814000